export default "__VITE_ASSET__d63de86b__"